import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Filtro, Ordenamiento, PaginaVacia } from '../../../models';


/**
 * Estado compartido de listados.
 *
 * Centraliza filtros, ordenamiento, pagina actual y tamanio de pagina para que
 * los modulos puedan construir params de busqueda y exportacion de forma uniforme.
 */
export const PaginaSlice = createSlice({
  name: 'filtros',
  initialState: PaginaVacia,
  reducers: {
    resetearPagina: () => ({
      ...PaginaVacia
    }),
    actualizarFiltros: (state, action: PayloadAction<Filtro[]>) => ({
      ...state,
      filtros: action.payload,
    }),
    eliminarFiltroPorClave: (state, action: PayloadAction<string>) => ({
      ...state,
      filtros: state.filtros.filter((filtro) => filtro.clave!== action.payload)
    }),
    establecerOrdenamiento: (state, action: PayloadAction<Ordenamiento>) => ({
      ...state,
      ordenamiento: action.payload
    }),
    establecerPagina: (state, action: PayloadAction<number>) => ({
      ...state,
      pagina: action.payload
    }),
    establecerNombrePagina: (state, action: PayloadAction<string>) => ({
      ...state,
      nombrePagina: action.payload
    }),
    establecerRegistrosPorPagina: (state, action: PayloadAction<number>) => ({
      ...state,
      registrosPorPagina: action.payload
    }),
  },
})

// Action creators are generated for each case reducer function
export const { actualizarFiltros, eliminarFiltroPorClave, establecerOrdenamiento, establecerRegistrosPorPagina, establecerPagina, establecerNombrePagina, resetearPagina } = PaginaSlice.actions
